/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaRowStatusStatistics model module.
 * @module model/AqaRowStatusStatistics
 * @version v0
 */
export default class AqaRowStatusStatistics {
  /**
   * Constructs a new <code>AqaRowStatusStatistics</code>.
   * @alias module:model/AqaRowStatusStatistics
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaRowStatusStatistics</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaRowStatusStatistics} obj Optional instance to populate.
   * @return {module:model/AqaRowStatusStatistics} The populated <code>AqaRowStatusStatistics</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaRowStatusStatistics();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('numberOfPendingRed'))
        obj.numberOfPendingRed = ApiClient.convertToType(data['numberOfPendingRed'], 'Number');
      if (data.hasOwnProperty('numberOfIgnoreRed'))
        obj.numberOfIgnoreRed = ApiClient.convertToType(data['numberOfIgnoreRed'], 'Number');
      if (data.hasOwnProperty('numberOfFixedRed'))
        obj.numberOfFixedRed = ApiClient.convertToType(data['numberOfFixedRed'], 'Number');
      if (data.hasOwnProperty('numberOfIgnoreAmber'))
        obj.numberOfIgnoreAmber = ApiClient.convertToType(data['numberOfIgnoreAmber'], 'Number');
      if (data.hasOwnProperty('numberOfFixedAmber'))
        obj.numberOfFixedAmber = ApiClient.convertToType(data['numberOfFixedAmber'], 'Number');
      if (data.hasOwnProperty('numberOfPendingAmber'))
        obj.numberOfPendingAmber = ApiClient.convertToType(data['numberOfPendingAmber'], 'Number');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaRowStatusStatistics.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaRowStatusStatistics.prototype.message = undefined;

/**
 * @member {Number} numberOfPendingRed
 */
AqaRowStatusStatistics.prototype.numberOfPendingRed = undefined;

/**
 * @member {Number} numberOfIgnoreRed
 */
AqaRowStatusStatistics.prototype.numberOfIgnoreRed = undefined;

/**
 * @member {Number} numberOfFixedRed
 */
AqaRowStatusStatistics.prototype.numberOfFixedRed = undefined;

/**
 * @member {Number} numberOfIgnoreAmber
 */
AqaRowStatusStatistics.prototype.numberOfIgnoreAmber = undefined;

/**
 * @member {Number} numberOfFixedAmber
 */
AqaRowStatusStatistics.prototype.numberOfFixedAmber = undefined;

/**
 * @member {Number} numberOfPendingAmber
 */
AqaRowStatusStatistics.prototype.numberOfPendingAmber = undefined;

/**
 * @member {Boolean} successful
 */
AqaRowStatusStatistics.prototype.successful = undefined;

